import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGitkrakenComponent } from './simple-icons-gitkraken.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGitkrakenComponent ],
    exports:      [ SimpleIconsGitkrakenComponent ],
    bootstrap:    []
})
export class SimpleIconsGitkrakenModule {}
